import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectChairsObject } from "../../../store/Chairs/ChairsSlice";
import { selectAgentsArray } from "../../../store/Avatars/AvatarsSlice"; 
import Agent from './Agent'; 
import { getAgent } from '../../../store/Avatars/AvatarsThunks';

const Agents = ({ avatarBounds, mapRef, mapConfig, zoomLevel }) => {
  const dispatch = useDispatch();
  
  const { agents, loading } = useSelector((state) => state.avatars);
  const chairsObject = useSelector(selectChairsObject);
  
  const agentssArray = useSelector(selectAgentsArray);

  const overlays = useRef({});

  useEffect(() => {
    dispatch(getAgent());
  }, []);

  useEffect(() => {
    Object.keys(overlays.current).forEach((overlayId) => {
      const agentId = overlayId.split('-')[1];
      if (!agents[agentId]) {
        if (overlays.current[overlayId].remove) {
          overlays.current[overlayId].remove();
        }
        delete overlays.current[overlayId];
      }
    });
  }, [agents]);

  if (loading && agentssArray.length === 0) {
    return null;
  }

  return (
    <>
      {agentssArray.map((agent) => (
        <Agent
          key={agent.id} 
          chair={chairsObject[agent.chair_id]}
          agent={agent}
          agentBounds={avatarBounds}
          mapRef={mapRef}
          overlays={overlays}
          mapConfig={mapConfig}
          zoomLevel={zoomLevel}
        />
      ))}
    </>
  );
};

export default Agents;